import type { SxProps, Theme } from '@mui/material';

export const styles = {
    root: {
        '&[disabled]': {
            color: '#CAD2D9',
            cursor: 'default',
            '&:hover': { textDecoration: 'none' },
        },
    } as SxProps<Theme>,
};
